export default "__VITE_ASSET__C9WKh8lk__"